import { Action } from '@ngrx/store';
import { MyMeasuresCategory, MyMeasuresEntry } from './my-measures.models';

export enum MyMeasuresActionTypes {
  LOAD_CHART = 'MyMeasuresAction Load chart',
  LOAD_CHART_FAILED = 'MyMeasuresAction Load chart failed',
  LOAD_CHART_SUCCESS = 'MyMeasuresAction Load chart success',
  LOAD_CATEGORIES = '[MyMeasuresAction] Load categories',
  LOAD_CATEGORIES_FAILED = '[MyMeasuresAction] Load categories failed',
  LOAD_CATEGORIES_SUCCESS = '[MyMeasuresAction] Load categories success',
  LOAD_MEASURES_LIST = '[MyMeasuresAction] Load measures list',
  LOAD_MEASURES_LIST_FAILED = '[MyMeasuresAction] Load measures list failed',
  LOAD_MEASURES_LIST_SUCCESS = '[MyMeasuresAction] Load measures list success',
  SET_SELECTED_MEASURE = '[MyMeasuresAction] Set selected Measure',
  SET_SELECTED_CATEGORY = '[MyMeasuresAction] Set selected category',
  RESET_MY_MEASURES_STORE = '[MyMeasuresAction] Reset Measures store'
}

export class MyMeasuresActionLoadChart implements Action {
  readonly type = MyMeasuresActionTypes.LOAD_CHART;

  constructor(public payload?: string) {}
}

export class MyMeasuresActionLoadChartFailed implements Action {
  readonly type = MyMeasuresActionTypes.LOAD_CHART_FAILED;
}

export class MyMeasuresActionLoadChartSuccess implements Action {
  readonly type = MyMeasuresActionTypes.LOAD_CHART_SUCCESS;

  constructor(public payload: any) {}
}

export class MyMeasuresActionLoadMeasuresList implements Action {
  readonly type = MyMeasuresActionTypes.LOAD_MEASURES_LIST;
}

export class MyMeasuresActionLoadMeasuresListFailed implements Action {
  readonly type = MyMeasuresActionTypes.LOAD_MEASURES_LIST_FAILED;
}

export class MyMeasuresActionLoadMeasuresListSuccess implements Action {
  readonly type = MyMeasuresActionTypes.LOAD_MEASURES_LIST_SUCCESS;

  constructor(public payload: Array<MyMeasuresEntry>) {}
}

export class MyMeasuresActionSetSelectedMeasure implements Action {
  readonly type = MyMeasuresActionTypes.SET_SELECTED_MEASURE;

  constructor(public payload: MyMeasuresEntry) {}
}

export class MyMeasuresActionLoadCategories implements Action {
  readonly type = MyMeasuresActionTypes.LOAD_CATEGORIES;
}

export class MyMeasuresActionLoadCategoriesFailed implements Action {
  readonly type = MyMeasuresActionTypes.LOAD_CATEGORIES_FAILED;
}

export class MyMeasuresActionLoadCategoriesSuccess implements Action {
  readonly type = MyMeasuresActionTypes.LOAD_CATEGORIES_SUCCESS;

  constructor(public payload: Array<MyMeasuresCategory>) {}
}

export class MyMeasuresActionSetSelectedCategory implements Action {
  readonly type = MyMeasuresActionTypes.SET_SELECTED_CATEGORY;

  constructor(public payload: MyMeasuresCategory) {}
}

export class MyMeasuresActionResetMyMeasuresStore implements Action {
  readonly type = MyMeasuresActionTypes.RESET_MY_MEASURES_STORE;
}

export type MyMeasuresActions =
  | MyMeasuresActionLoadChart
  | MyMeasuresActionLoadChartFailed
  | MyMeasuresActionLoadChartSuccess
  | MyMeasuresActionLoadCategories
  | MyMeasuresActionLoadCategoriesFailed
  | MyMeasuresActionLoadCategoriesSuccess
  | MyMeasuresActionLoadMeasuresList
  | MyMeasuresActionLoadMeasuresListFailed
  | MyMeasuresActionLoadMeasuresListSuccess
  | MyMeasuresActionSetSelectedMeasure
  | MyMeasuresActionSetSelectedCategory
  | MyMeasuresActionResetMyMeasuresStore;
